import React,{useState,useEffect} from 'react';
import { Button } from 'react-bootstrap';
import DataTableAttendanceDetail from '../../components/datatable/DataTableAttendanceDetail';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';
import * as moment from 'moment';
import 'moment/locale/sk';



const AttendanceDetailDatatable = (props) => {
    
    const [t] = useTranslation();
 
    const {i18n} = useTranslation();

    const [state, setState] = useState({url: '',urlExcel: '',showType: 'Day',checkTime: Date.now()}); //

   // const [checkTime, setCheckTime] = useState(null);
   // const [selectedRecord, setSelectedRecord] = useState();
    const tableName = t('attendance.label.detail'); 
   

   

  
    


    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
        }

    const getDayName = (id,value) => {
        //console.log(i18n.language);
        moment.locale(i18n.language);
        let f = moment(value, "DD.MM.YYYY").format("dddd");
        if(typeof(id) !== 'undefined'){
            
        }else{
            f="";
        }
        return (<span>{capitalize(f)}</span>);
    }

    //const getHours = (value) => {
   //     if(value==null){
    //        return '';
    //    }else{
     //       return moment.duration(value,'milliseconds').format('HH:mm',{trim: false });
     //   }
   // }
    
    const conditionalRowStyles = [
        {
          when: row => row.weekend === 1 ,
          style: {
            backgroundColor: "green",
            userSelect: "none"
          }
        }
      ];

      const clickHandler = (row) => {
         //row.target.id      
            props.parentCallback(row.target.id);                       
      };

    const removeZeroValues  = (value) => {

     
      if(value==='00:00' || value===0){value='';}

      return (
        <>
        {value}
        </>
      );
    }

    const approvedStatus = (row) => {
      let approvedText = "";
      let approvedColor = "";
      if(row.id!==null){
          switch(row.approved){
              case 1:
                  approvedText="Schvaluje sa...";
                  approvedColor = "#FFA500";
              break;
              case 2:
                  approvedText="Schválený";
                  approvedColor = "#228B22";
              break;
              case 3:
                  approvedText="Zamietnutý";
                  approvedColor = "#FF0000";
              break;
              default:
                  approvedText="";
                  approvedColor = "";
          }
      }
      
      return (<>
                  <span style={{"color": approvedColor}}>
                      {approvedText}
                  </span>
              </>);
     
    }

    let columns = [       
        { name: "Id",  selector: "id", omit: true},        
        { name: "Weekend",  selector: "weekend", omit: true},
        { name: t('attendance.label.date'),  sortable: false, selector: "date"},
        { name: t('attendance.label.day'),  sortable: false, selector: d => {
            return getDayName(d.id,d.date);
        }},
      //  { name: t('attendance.label.saldo'), data: "month",  sortable: true,  selector: "saldoText"},
        { name: t('attendance.label.sumWork'),  sortable: false, selector: "sumWorkText", cell:(row) => removeZeroValues(row.sumWorkText) },
        { name: t('attendance.label.sumLunch'), sortable: false, selector: "sumLunchText", cell:(row) => removeZeroValues(row.sumLunchText) },
        { name: t('attendance.label.sumDoctor'), sortable: false, selector: "sumDoctorText", cell:(row) => removeZeroValues(row.sumDoctorText) },
        { name: t('attendance.label.sumDoctorWithFamily'), sortable: false, selector: "sumDoctorWithFamilyText", cell:(row) => removeZeroValues(row.sumDoctorWithFamilyText) },
        { name: t('attendance.label.sumHoliday'),  sortable: false, selector: "sumHolidayText", cell:(row) => removeZeroValues(row.sumHolidayText) },
        { name: t('attendance.label.sumBusinessTrip'), sortable: false, selector: "sumBusinessTripText", cell:(row) => removeZeroValues(row.sumBusinessTripText) },
        { name: t('attendance.label.sumOther'),  sortable: false,  selector: "sumOtherText", cell:(row) => removeZeroValues(row.sumOtherText) },
       
        //{ name: t('attendance.label.sumAll'),  sortable: false, selector: "sumAllText"},
        { name: t('attendance.label.saldo'),  sortable: false, selector: "saldoText", cell:(row) => removeZeroValues(row.saldoText)},
        { name: t('attendance.label.saldoDiff'),  sortable: false, selector: "saldoDiffText", cell:(row) => removeZeroValues(row.saldoDiffText)},
        { name: t('attendance.label.mealTicket'),  sortable: false, selector: "mealTicket", cell:(row) => removeZeroValues(row.mealTicket)},
        { name: t('attendance.label.sourceOfEvents'),  sortable: false, selector: "sourceOfEvents"},
        { name: t('general.label.whatDid'),  sortable: false, selector: "whatDid"},
        
        { name: t('general.button.edit'), cell:(row) => row.id  ? <Button className="btn-default"  onClick={clickHandler} id={row.id} name={row.name} >{t('general.button.edit')}</Button> : "",
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        omit: !props.editEnabled
        
     }
        
    ];        


    
    let columnsData = [       
       // { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},       
        { name: t('attendance.label.date'), data: "date",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: "Weekend", data: "weekend", searchable: false, orderable: false, search: {value: '',regex: false}},
       // { name: t('attendance.label.saldo'), data: "saldoText", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('attendance.label.sumWork'), data: "sumWorkText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumLunch'), data: "sumLunchText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumDoctor'), data: "sumDoctorText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumDoctorWithFamily'), data: "sumDoctorWithFamilyText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumHoliday'), data: "sumHolidayText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumBusinessTrip'), data: "sumBusinessTripText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.sumOther'), data: "sumOtherText", searchable: false, orderable: false, search: {value: '',regex: false}},
       // { name: t('attendance.label.sumAll'), data: "sumAllText", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('attendance.label.saldoDiff'), data: "saldoDiffText", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('attendance.label.mealTicket'), data: "mealTicket", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('general.label.whatDid'), data: "whatDid", searchable: false, orderable: false, search: {value: '',regex: false}}
     
     
        
        
    ];        


    let columnsSubRow = [       
        { name: t('attendance.label.code'),  data: "attendanceCode.code", selector: d => t('attendance.label.'+d.attendanceCode.code)},        
        { name: t('attendance.label.start'),  data: "start", selector: d => moment(d.start).format("DD.MM.YYYY HH:mm")},
        { name: t('attendance.label.stop'),  data: "stop", selector: d => moment(d.stop).format("DD.MM.YYYY HH:mm")},
        { name: t('general.label.description'),  data: "description", selector: "description"},
        { name: t('attendance.label.approved'),  sortable: false, selector: "approved",
        cell:(row) => approvedStatus(row)}
        
    ];    


    let columnsBasic = columns;
    let columnsDataBasic = columnsData;
    let columnsSubRowBasic = columnsSubRow;
   
    useEffect(() => {      


      columns = columnsBasic;
      columnsData = columnsDataBasic;
      columnsSubRow = columnsSubRowBasic;

      if(props.state.showType=='Day'){
        

        setState({...state,
          showType: props.state.showType,
          checkTime: Date.now(),
          selectedRecord: props.state.selectedRecord,
          url:  RestService.getBaseURL()+"attendance/getAttendanceDetailList?attendanceId="+props.state.selectedRecord,
          urlExcel: RestService.getBaseURL()+"attendance/getAttendanceDetailListExcel?attendanceId="+props.state.selectedRecord,
          columns: columns,
          columnsData: columnsData,
          columnsSubRow: columnsSubRow,
          expandableRows: true
        });      
        
        
      //  columnsData = columnsDataBasic;


      }else{

        
        columns.forEach((res, index) => {

          if(index==2){
            res.name = t('attendance.label.week');
            res.selector = "week";
          }
          if (index==3) {
            columns.splice(index, 1) // remove element
      //      columnsData.splice(index, 1) // remove element
          }
        })

        columnsData.forEach((res, index) => {

          if(index==0){
            res.name = t('attendance.label.week');
            res.data = "week";
          }        
        })

        setState({...state,
          showType: props.state.showType,
          checkTime: Date.now(),
          selectedRecord: props.state.selectedRecord,
          url:  RestService.getBaseURL()+"attendance/getAttendanceWeekList?attendanceId="+props.state.selectedRecord,
          urlExcel: RestService.getBaseURL()+"attendance/getAttendanceWeekListExcel?attendanceId="+props.state.selectedRecord,
          columns: columns,
          columnsData: columnsData,
          columnsSubRow: undefined,
          expandableRows: false
        });


        

      }

     
      //setCheckTime(props.checkTime);      
    }, [props.state])

 
    // useEffect(() => {      
    //    setSelectedRecord(props.selectedRecord);
     // }, [props.selectedRecord])


   //   useEffect(() => {      
  //      setCheckTime(props.checkTime);
   //   }, [props.checkTime])


     const handleCallback  = (id) => {
        props.parentCallback(id)
                     //console.log(id)
     };
   

   
          
    
         return (
           
            <>
             <DataTableAttendanceDetail
                 url={state.url}  
                 urlExcel={state.urlExcel}  
                 tableName={tableName}
                 columns={state.columns}   
                 columnsData={state.columnsData}
                 parentCallback={handleCallback}
                 modalShow={state.showAddDay} //{props.modalShow}
                 exportShow={false}
                 expandableRows={state.expandableRows}
                 columnsSubRow={state.columnsSubRow}
                 conditionalRowStyles={conditionalRowStyles}
                 checkTime={state.checkTime}        
             />

           
           
             </>
         );
    
 
  
 };

export default AttendanceDetailDatatable;

